import { HTMLAttributes, forwardRef } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center font-heading font-bold uppercase text-xs tracking-wider border-[3px] border-dark px-3 py-1",
  {
    variants: {
      variant: {
        default: "bg-primary text-dark",
        secondary: "bg-card text-dark",
        warning: "bg-warning text-dark",
        success: "bg-success text-white",
        error: "bg-destructive text-white",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface BrutalBadgeProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

const BrutalBadge = forwardRef<HTMLDivElement, BrutalBadgeProps>(
  ({ className, variant, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(badgeVariants({ variant }), className)}
        {...props}
      />
    );
  }
);

BrutalBadge.displayName = "BrutalBadge";

export { BrutalBadge, badgeVariants };
